// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// components
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueSidebarMenu from 'vue-sidebar-menu'
import VueI18n from 'vue-i18n'
import messages from './i18nMessages'
import IdleVue from 'idle-vue'
import { ValidationProvider, ValidationObserver, extend, validate, localize, configure } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import it from 'vee-validate/dist/locale/it.json'
import en from 'vee-validate/dist/locale/en.json'
import LangFlag from 'vue-lang-code-flags'
import { ModelListSelect, MultiSelect } from 'vue-search-select'
import AccessMotivation from '@/components/vue-plugins/AccessMotivation'
import StandardTable from '@/components/vue-plugins/StandardTable'
import FileUploader from '@/components/vue-plugins/FileUploader'
import LinkList from '@/components/vue-plugins/LinkList'
import NumberFlip from '@/components/vue-plugins/NumberFlip'
import CalendarPicker from '@/components/vue-plugins/Calendarpicker'
import Popup from '@/components/vue-plugins/Popup'
import Map from '@/components/vue-plugins/Map/Map'
import explorer from '@/components/vue-plugins/explorer'
import VueFlatPickr from 'vue-flatpickr-component'
import { ToggleButton } from 'vue-js-toggle-button'
import VueSlider from 'vue-slider-component'
import { first } from 'lodash'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { SimpleSVG } from 'vue-simple-svg'
import { InlineSvgPlugin } from 'vue-inline-svg'

// style css
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'flatpickr/dist/flatpickr.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-slider-component/theme/default.css'

// font awesome icons
import {
  faMapMarkedAlt,
  faCheckCircle,
  faCircle,
  faAngleUp,
  faAngleDown,
  faPencilAlt,
  faTrash,
  faEye,
  faInfoCircle,
  faWrench,
  faBars,
  faEnvelope,
  faSearch,
  fas,
  faFileAlt,
  faFolder,
  faFolderOpen,
  faPlus,
  faDownload,
  faHandPaper,
  faBan,
  faSignOutAlt,
  faBalanceScale,
  faEuroSign,
  faPlusCircle,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faMapMarkedAlt,
  faCircle,
  faAngleUp,
  faAngleDown,
  faPencilAlt,
  faTrash,
  faEye,
  faInfoCircle,
  faWrench,
  faBars,
  faEnvelope,
  faSearch,
  fas,
  faFileAlt,
  faFolder,
  faFolderOpen,
  faPlus,
  faDownload,
  faHandPaper,
  faBan,
  faSignOutAlt,
  faCheckCircle,
  faBalanceScale,
  faEuroSign,
  faPlusCircle,
  faQuestionCircle
)
Vue.use(InlineSvgPlugin);
Vue.use(BootstrapVue)
Vue.use(VueSidebarMenu)
Vue.use(VueI18n)
Vue.use(VueFlatPickr, { readonly: false })
Vue.config.productionTip = false

extend('taxCode', {
  validate: value => new RegExp(/^[A-Za-z]{6}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{2}[A-Za-z]{1}[0-9LMNPQRSTUV]{3}[A-Za-z]{1}$/g).test(value)
})
it.messages.taxCode = field => 'Il campo ' + field + ' non è valido'
en.messages.taxCode = field => 'The ' + field + ' field is not valid'

extend('passwordCheck', {
  validate: (value, arrayOptions) => {
    const firstValue = value
    const secondValue = arrayOptions && arrayOptions[1]

    if (!firstValue) return null
    if (firstValue && secondValue) return firstValue === secondValue
    return false
  }
})
it.messages.passwordCheck = (value, arrayOptions) => {
  const firstLabel = arrayOptions[2]
  const secondLabel = arrayOptions[3]
  if (firstLabel && secondLabel) return `La password del campo ${firstLabel} non combacia con la password del campo ${secondLabel}`
  return 'La password di conferma non corrisponde alla password principale'
}
en.messages.passwordCheck = (value, arrayOptions) => {
  const firstLabel = arrayOptions && arrayOptions[2]
  const secondLabel = arrayOptions && arrayOptions[3]
  if (firstLabel && secondLabel) return `Password in ${firstLabel} field does not match with password in ${secondLabel} field`
  return 'Password check does not match with main password'
}
extend('checkCalendar', {
  validate: (value, options) => {
    const calendar = first(options)
    if (!value) return null
    return !!calendar
  }
})
it.messages.checkCalendar = (value) => {
  if (!value) return null
  return 'Non è presente alcun calendario standard per la struttura selezionata'
}
en.messages.checkCalendar = (value) => {
  if (!value) return null
  return 'There are no standard calendar for selected structure'
}

for (const rule in rules) {
  extend(rule, rules[rule])
}

localize({ it, en })

const validationConfig = {
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  bails: true,
  skipOptional: true,
  mode: 'aggressive',
  useConstraintAttrs: true
}

const i18n = new VueI18n({ locale: navigator.language === 'it-IT' ? 'it' : 'en', messages, preserveDirectiveContent: true })

const eventsHub = new Vue()
const seconds = 60
const milliseconds = 1000
const minutes = 15

configure(validationConfig)

Vue.use(IdleVue, { eventEmitter: eventsHub, idleTime: minutes * seconds * milliseconds })
Vue.directive('validate', validate())
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('model-list-select', ModelListSelect)
Vue.component('multi-select', MultiSelect)
Vue.component('standard-table', StandardTable)
Vue.component('access-motivation', AccessMotivation)
Vue.component('file-uploader', FileUploader)
Vue.component('switch-button', ToggleButton)
Vue.component('Map', Map)
Vue.component('link-list', LinkList)
Vue.component('number-flip', NumberFlip)
Vue.component('calendar-picker', CalendarPicker)
Vue.component('slider', VueSlider)
Vue.component('popup', Popup)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
Vue.component('flag', LangFlag)
Vue.component('explorer', explorer)
Vue.component('simple-svg', SimpleSVG)

window.onload = () => {
  const newStart = new Date().getTime()
  const lastEnd = Vue.getLocalStorage('destroyed')
  const millis = 1000
  const seconds = 10
  const timeout = seconds * millis
  let tabs = Vue.getLocalStorage('tabs')
  Vue.deleteLocalStorage('created')
  Vue.setLocalStorage('created', newStart)

  if (newStart - lastEnd > timeout && tabs === null) {
    Vue.deleteLocalStorage('session')
    Vue.deleteLocalStorage('routes')
    router.push({ name: 'Logout' })
  } else {
    Vue.deleteLocalStorage('destroyed')
  }

  if (tabs) {
    tabs += 1
    Vue.setLocalStorage('tabs', tabs)
  } else {
    tabs = 1
    Vue.setLocalStorage('tabs', tabs)
  }
}

window.onunload = () => {
  Vue.deleteLocalStorage('destroyed')
  Vue.setLocalStorage('destroyed', new Date().getTime())

  let inactive = Vue.getLocalStorage('inactive')
  let tabs = Vue.getLocalStorage('tabs')
  if (tabs) {
    tabs -= 1
    Vue.setLocalStorage('tabs', tabs)
  }

  if (tabs === 0) {
    Vue.deleteLocalStorage('tabs')
  }

  if (inactive && inactive >= 1) {
    inactive -= 1
    Vue.setLocalStorage('inactive', inactive)
  }

  if (inactive < 1) {
    Vue.setLocalStorage('inactive', 0)
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App :idle="messageStr"/>',
  components: { App },
  data () {
    return {
      messageStr: false
    }
  },
  onIdle () {
    this.messageStr = true
  },
  onActive () {
    this.messageStr = false
  }
})
